import { Fade, makeStyles, Typography } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { transitionTimeout } from '../ClaimWizard';
import { ClaimContext } from '../../../../contexts/ClaimContext';
import { separations } from '../../../../constants/StyleConstants';
import ServicePage from '../../../ServicePage/ServicePage';

const useStyles = makeStyles(theme => ({
  ...separations,
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
}));

const ServicePageSelection = ({ setServicePage }) => {
  const classes = useStyles();
  const { setStepElements, stepForward } = useContext(ClaimContext);
  const [transIn, setTransIn] = useState(true);

  useEffect(() => {
    const step = {
      stepNumber: 1,
      backButtonText: 'Cancelar y elegir otro tipo de reclamo',
      nextButtonText: 'Reclamo por Hoja de Servicio Inexistente',
      transition: {
        enter: () => setTransIn(true),
        exit: () => setTransIn(false),
      },
    };

    setStepElements(step.stepNumber, step);
    setServicePage(null);
  }, []);

  const handleSelection = (event, rowData) => {
    setServicePage(rowData);
    stepForward();
  };

  return (
    <Fade in={transIn} timeout={transitionTimeout} unmountOnExit>
      <div className={classes.root}>
        <Typography className={classes.bottomSeparation} variant="subtitle2">
          Seleccione una hoja de servicio haciendo click en la fila correspondiente
        </Typography>
        <ServicePage fullResponsive onRowClick={handleSelection} />
      </div>
    </Fade>
  );
};

export default ServicePageSelection;
